<div *ngIf="!templates">
    <ul class="nav nav-tabs" [ngClass]="class" id="myTab" role="tablist">
        <li class="nav-item" role="presentation" *ngFor="let property of properties;let i = index"
            (click)="onClick(property.header)">
            <button *ngIf="property.active" class="nav-link active" data-bs-toggle="tab" id="A{{i}}{{name}}"
                attr.data-bs-target="#A{{i}}" type="button" role="tab" attr.aria-controls="A{{i}}"
                aria-selected="false">{{property.header}}</button>

            <button *ngIf="!property.active" class="nav-link" data-bs-toggle="tab" id="A{{i}}{{name}}"
                attr.data-bs-target="#A{{i}}" type="button" role="tab" attr.aria-controls="A{{i}}"
                aria-selected="false">{{property.header}}</button>
        </li>
    </ul>
</div>
<div *ngIf="templates" class="nav_template">
    <ul class="nav nav-tabs" [ngClass]="class" id="myTab" role="tablist">
        <li class="nav-item" role="presentation" *ngFor="let property of properties;let i = index"
            (click)="onClick(property.header)">
            <button *ngIf="property.active" class="nav-link active" data-bs-toggle="tab" id="A{{i}}{{name}}"
                attr.data-bs-target="#A{{i}}" type="button" role="tab" attr.aria-controls="A{{i}}"
                aria-selected="false">{{property.header}}</button>

            <button *ngIf="!property.active" class="nav-link" data-bs-toggle="tab" id="A{{i}}{{name}}"
                attr.data-bs-target="#A{{i}}" type="button" role="tab" attr.aria-controls="A{{i}}"
                aria-selected="false">{{property.header}}</button>
        </li>
    </ul><!--Remove Id id="B{{i}}"-->
    <div *ngFor="let property of properties; index as i" class="tab-content" id="myTabContent">

        <div *ngIf="property.active" class="tab-pane fade active show" role="tabpanel" attr.aria-labelledby="B{{i}}">
            <ng-container *ngTemplateOutlet="templates?.[i]"></ng-container>
        </div>
        <div *ngIf="!property.active" class="tab-pane fade" role="tabpanel" attr.aria-labelledby="B{{i}}">
            <ng-container *ngTemplateOutlet="templates?.[i] "></ng-container>
        </div>
        <!--Remove id="A{{i}}"-->
    </div>
</div>